import confetti from "canvas-confetti";

export function useConfetti() {
  return {
    burst() {
      confetti({ particleCount: 80, spread: 60, origin: { y: 0.7 } });
    },
    streak() {
      // Two bursts from the sides for milestone moments
      confetti({ particleCount: 50, angle: 60, spread: 50, origin: { x: 0, y: 0.6 } });
      confetti({ particleCount: 50, angle: 120, spread: 50, origin: { x: 1, y: 0.6 } });
    },
  };
}
